// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Footer from './Footer';
import MobileMenu from './MobileMenu';

// const Wrapper = styled.div`
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     position: relative;
//     min-height: 100vh;
//     background: ${({theme}) => theme.body};
//     color: ${({theme}) => theme.text};
// `;
// const Content = styled.div`
//     display: flex;
//     flex-direction: column;
//     flex-grow: 1;
//     justify-content: center;
//     align-items: center;
//     width: 100vw;
//     padding: 0 0 2em 0;
//     flex-grow: 0;
//     padding: 0 0;
//     overflow: overlay;

//     height: ${({ height }) => height - 150}px;
// `;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // min-height: ${window.innerHeight - 65}px;
    height: ${window.innerHeight - 65}px;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};

    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    width: 100vw;
    padding: 0 0 2em 0;
    flex-grow: 0;
    padding: 0 0;
    overflow: auto;

    padding-top: 60px;
`;
const MobileLayout = ({ children, ...props }) => {
    const theme = useTheme();
    document.getElementById('themeColor').content = theme.secondary;

    return (
        <Wrapper>
            <MobileMenu />
            {children}
        </Wrapper>
    );
}

export default MobileLayout;